import { Injectable } from "@angular/core";
import { Action, State, StateContext } from "@ngxs/store";

import { CloseSideMenu, OpenSideMenu, ToggleSideMenu } from "./application.actions";

export interface ApplicationStateModel {
  sideMenuOpened: boolean
}

@State<ApplicationStateModel>({
  name: 'application',
  defaults: {
    sideMenuOpened: false
  }
})
@Injectable()
export class ApplicationState {
  @Action(OpenSideMenu)
  openSideMenu(
    { patchState }: StateContext<ApplicationStateModel>
  ) {
    patchState({sideMenuOpened: true})
  }

  @Action(CloseSideMenu)
  closeSideMenu(
    { patchState }: StateContext<ApplicationStateModel>
  ) {
    patchState({sideMenuOpened: false})
  }

  @Action(ToggleSideMenu)
  toggleSideMenu(
    { getState, patchState }: StateContext<ApplicationStateModel>
  ) {
    const sideMenuCurrentState = getState().sideMenuOpened;
    patchState({sideMenuOpened: !sideMenuCurrentState});
  }
}